import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { ClientTableViewColumnIdentifiers } from '@modules/common/models/enums/ClientTableViewColumnIdentifiers'
import { ClientTableViewColumnLabels } from '@modules/common/models/enums/ClientTableViewColumnLabels'
import { ClientTableViewFieldMapping } from '@modules/common/models/enums/ClientTableViewFieldMapping'
import { clientSearchViewComponentService } from './clientSearchViewComponentService'

class ClientSearchTableViewDefinitionService {
  //Note - Always pass currying function here
  buildTableViewDefinitionForClientSearch = (onRowClick = null, columnWidth = 480) => {
    return [
      new TableViewColumnDefinition({
        id: ClientTableViewColumnIdentifiers.Name,
        width: columnWidth,
        isRootColumn: true,
        header: {
          label: ClientTableViewColumnLabels.Name
        },
        node: {
          key: ClientTableViewFieldMapping.Name,
          component: clientSearchViewComponentService.getSearchWidgetLabelComponent
        },
        props: {
          onClick: onRowClick
        }
      })
    ]
  }
}

export const clientSearchTableViewDefinitionService =
  new ClientSearchTableViewDefinitionService()
